import localForage from 'localforage';

import { AuthState } from 'features/auth/ducks';

const PERSIST_KEY = 'persist:root';

export async function loadPersistedAuth(): Promise<AuthState | null> {
  try {
    const stored = await localForage.getItem<string>(PERSIST_KEY);
    if (!stored) {
      return null;
    }
    const parsed = JSON.parse(stored);
    if (!parsed.auth) {
      return null;
    }
    return JSON.parse(parsed.auth) as AuthState;
  } catch {
    return null;
  }
}

export async function savePersistedAuth(authState: AuthState): Promise<void> {
  try {
    await localForage.setItem(
      PERSIST_KEY,
      JSON.stringify({
        auth: JSON.stringify(authState),
        _persist: JSON.stringify({ version: 0, rehydrated: true }),
      }),
    );
  } catch {
    // Persistence is best-effort
  }
}

export async function clearPersistedAuth(): Promise<void> {
  try {
    await localForage.removeItem(PERSIST_KEY);
  } catch {
    // Persistence is best-effort
  }
}
